import script from "./MsDynamicPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MsDynamicPopup.vue?vue&type=script&setup=true&lang=js"

import "./MsDynamicPopup.vue?vue&type=style&index=0&id=9b0920ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b0920ee"]])

export default __exports__